import { render, staticRenderFns } from "./AdminEditionDetail.vue?vue&type=template&id=09c547d7&"
import script from "./AdminEditionDetail.vue?vue&type=script&lang=js&"
export * from "./AdminEditionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports